module.exports = __webpack_public_path__ + "media/images/icon-select-grey-411ba1b00645dea786d1fd11cf9ed3c4.png";